module.exports = __webpack_public_path__ + "8ccb22c6.svg";